// extracted by mini-css-extract-plugin
export var backgraund = "PortaFiltro-module--backgraund--b91ba";
export var children_section = "PortaFiltro-module--children_section--f83f7";
export var children_section2 = "PortaFiltro-module--children_section2--1111a";
export var container2 = "PortaFiltro-module--container2--3b3d2";
export var container_filtros = "PortaFiltro-module--container_filtros--183d8";
export var container_img = "PortaFiltro-module--container_img--ff95f";
export var container_img2 = "PortaFiltro-module--container_img2--59d9b";
export var container_inf = "PortaFiltro-module--container_inf--f10f1";
export var container_section = "PortaFiltro-module--container_section--645e2";
export var img_item = "PortaFiltro-module--img_item--25602";
export var img_item2 = "PortaFiltro-module--img_item2--49425";
export var img_item3 = "PortaFiltro-module--img_item3--9013c";
export var nextButton = "PortaFiltro-module--nextButton--7b129";
export var previousButton = "PortaFiltro-module--previousButton--fdd07";